import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import apiAgent from "../../../app/api/apiAgent";
//import LoadingComponent from "../../../app/layout/LoadingComponent";
import { useStore } from "../../../app/stores/store";
import HeaderWrapper from "../../header/HeaderWrapper";
import P24MatchBox from "./P24MatchBox";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";

export default observer(function P24MatchPage() {
  const {
    userStore: { userSession, logout, isLoggedIn },
  } = useStore();

  document.title = "Base - p24 Mapping";

  return (
    <>
      <div className="container-fluid">
        <Breadcrumb breadcrumbs={[{ text: "Home", path: "/" }, { text: "Settings", path: "/settings" }, { text: "P24 Mapping" }]} />

        <div className="row">
          <div className="hidden-sm col-md-2"></div>
          <div id="content" className="col-sm-12 col-md-8">
            <P24MatchBox />
          </div>
          <div className="hidden-sm col-md-2"></div>
        </div>
      </div>
    </>
  );
});
